module.exports = __webpack_public_path__ + "static/media/fablabLogo.647e85db.jpg";